<script>
import GenericForm from '@phoenix/mixins/components/form/GenericForm';
import FormGroup from '@maison/components/form/FormGroup.vue';
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    FormGroup,
  },

  mixins: [GenericForm],

  props: {
    isContained: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <div :data-cy="`${form.name}-form`">
    <phoenix-form
      v-if="!shouldDisplaySuccessSection"
      v-model="fields"
      :prefill-enabled="form.prefillEnabled"
      :redirect-url="redirectUrl"
      :terms-link="termsLink"
      :captcha-enabled="form.captchaEnabled"
      :action="form.action"
      :form-type="form.name"
      :custom-submit-text="form.submitLabel"
      :on-success-callback="onSuccess"
      :show-errors-in-toast="showErrorsInToast"
      :should-reset-form-on-submit="shouldResetFormOnSubmit"
      :should-include-browsing-history="true"
      :is-contained="isContained"
    >
      <div class="flex-grid flex-grid--x--md flex-grid--y--md">
        <div
          v-for="(column, columnKey) in form.columns"
          :key="`column-${columnKey}`"
          :class="`w-full md:w-1/${columnsCount}`"
        >
          <div class="flex-grid flex-grid--x--md flex-grid--y--md">
            <template v-for="field in column">
              <form-group
                v-if="shouldDisplayField(field)"
                :key="field"
                :attrs="fields[field]"
                :show-label="!['customText', 'checkbox'].includes(fields[field].type)"
                class="w-full"
              >
                <component
                  :is="getComponent(fields[field].type)"
                  v-model="fields[field].value"
                  :attrs="fields[field]"
                />
              </form-group>
            </template>
          </div>
        </div>
      </div>

      <slot name="form-before-actions" />
    </phoenix-form>

    <div v-else class="text-center">
      <h4>{{ $t('Form.generic.successTitle') }}</h4>
      <p>{{ form.successMessage }}</p>
    </div>
  </div>
</template>
